module.exports = __webpack_public_path__ + "static/media/no-network@3x.28b538de.png";